module.exports = __webpack_public_path__ + "img/SVK.292385b1.svg";